import { FC } from 'react'
import { useSelector } from 'react-redux'
import { ChatWidget as NewChat } from 'merinio-chat'

import { MerinioChat as LegacyChat } from './MerinioChat'

const MerinioChatContainer: FC<{ token?: string }> = ({ token }) => {
  const isNewChatActive = useSelector((state: MStore.RootState) => state.settings.enableNewChat)

  if (!token) return null

  if (isNewChatActive) return <NewChat />

  return <LegacyChat chatToken={token} />
}

export { MerinioChatContainer }
